import { render, staticRenderFns } from "./countryListRisk.vue?vue&type=template&id=07d2b2c1&scoped=true&"
import script from "./countryListRisk.vue?vue&type=script&lang=js&"
export * from "./countryListRisk.vue?vue&type=script&lang=js&"
import style0 from "./countryListRisk.vue?vue&type=style&index=0&id=07d2b2c1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d2b2c1",
  null
  
)

export default component.exports